<template>
	<div class="page-in">
		<van-nav-bar :title="$t('确认订单')" fixed placeholder left-arrow z-index="99" @click-left="back" :border="false"
			v-if="isMobileFlag" />
		<div class="inside-page">
			<div class="m-container" v-if="isMobileFlag">
				<template v-if="$store.state.isLoginStatu">
					<div class="panel-m-select" v-if="defaultAddress">
						<div class="m-select-card" @click="showAddress">
							<div class="iconfont icon-address"></div>
							<div class="flex-col">
								<div class="m-card-title">
									<span class="s-name">{{defaultAddress.name}}</span>
									<span>{{defaultAddress.phone}}</span>
								</div>
								<div class="m-card-desc">
									{{defaultAddress.detail}}
								</div>
							</div>
							<div class="iconfont icon-l-right"></div>
						</div>
					</div>
					<div class="confirm-panel_hd" v-else>
						<div class="tt">{{$t('选择收货地址')}}</div>
						<el-link type="info" @click="goUrl('/address')">{{$t('管理收货地址')}}</el-link>
					</div>
				</template>
				<div class="panel-m-select" v-else>
					<div class="m-select-card" @click="addshow = true">
						<div class="iconfont icon-address"></div>
						<div class="flex-col">
							<div class="m-card-title">
								{{isAdd?$t('修改地址'):$t('添加地址')}}
							</div>
						</div>
						<div class="iconfont icon-l-right"></div>
					</div>
				</div>


				<div class="m-goods">
					<div class="m-goods-cell" v-for="(item,index) in orderProduct" :key="index">
						<div class="m-goods-row">
							<div class="m-photo">
								<img :src="item.image" alt="" />
							</div>
							<div class="flex-col">
								<div class="m-goods-title ellipsis">{{item.title}}</div>
								<div class="m-goods-item ">
									{{$t('规格')}}：{{item.sku}}
								</div>
								<div class="m-goods-item ">
									{{$t('数量')}}：{{item.num}}
								</div>
								<div class="m-goods-item ">
									<span class="item-price text-primary">{{formatNumber(item.price * item.num)}}
										VND</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="confirm-m-foot" >
					<el-form ref="addressform" label-position="top" :model="addressform">
						<el-form-item :label="$t('支付方式')">
							<el-select style="width: 100%;" v-model="addressform.pay_type" :placeholder="$t('请选择支付方式')"
								@change="changePayType" >
								<el-option :label="$t('在线支付')" value="1"></el-option>
								<el-option :label="$t('货到付款')" value="2"></el-option>
								<el-option :label="$t('银行转账')" value="3"></el-option>
							</el-select>
						</el-form-item>
					</el-form>
					
					<template v-if="$store.state.isLoginStatu">
					<el-form ref="form" label-position="top" :model="form" label-width="110px">
						<el-form-item :label="$t('选择使用优惠券')">
							<el-select style="width: 100%;" v-model="form.coupon" :placeholder="$t('选择使用优惠券')" @change="couponChange">
								<el-option v-for="(item,indexI) in myCoupons" :key="item.id" :value="item.id"
									:label="formatNumber(item.reduce) + $t('VND') + $t('优惠券')">
									<span>{{formatNumber(item.reduce)}}{{$t('VND')}}{{$t('优惠券')}}</span>
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item >
							<template slot="label">
								{{$t('是否使用积分抵扣')}} <span class="text-primary">({{dividends - dividendsLess}} {{$t('积分')}})</span>
							</template>
							
							 <el-radio-group v-model="form.is_integral" @input="integralChange">
							    <el-radio :label="0">
									{{$t('不使用')}}
								</el-radio>
								<el-radio :label="1">
									{{$t('使用')}}
								</el-radio>
							  </el-radio-group>
						</el-form-item>
						
						<div class="item" v-if="$store.state.isLoginStatu">
						      {{$t('积分抵消')}}：
						      <span class="price-v text-primary">{{ formatNumber(dividendsLess) }} {{$t('VND')}}</span>
						</div>
					</el-form>
					</template>
					<div class="agreement-foot">
						<el-checkbox v-model="agrreChecked">
							{{$t('同意本网站的条款和条件')}}
						</el-checkbox>
					</div>
				</div>
				<div class="order-tabber">
					<div class="flex-col">
						<div class="totaol-price ">
							<div class="item" v-if="$store.state.isLoginStatu">{{$t('优惠券减免')}}：<span
									class="price-v text-primary">{{ formatNumber(discountAmount) }} {{$t('VND')}}</span>
							</div>
							<div class="item">
								{{$t('合计')}}<span class="price-v text-primary">{{ formatNumber(finalAmount) }}
									{{$t('VND')}}</span>
							</div>
						</div>
					</div>
					<el-button type="primary" @click="goOrderAdd">{{$t('立即购买')}}</el-button>
				</div>
			</div>
			<!-- pc -->
			<div class="layui-container" v-else>
				<div class="brread-box">
					<el-breadcrumb separator="/">
						<el-breadcrumb-item :to="{ path: '/' }">{{$t('首页')}}</el-breadcrumb-item>
						<el-breadcrumb-item :to="{ path: '/category' }">{{$t('商品列表')}}</el-breadcrumb-item>
						<el-breadcrumb-item>{{$t('确认订单信息')}}</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
				<div class="confirm-panel">
					<div class="confirm-panel_hd">
						<div class="tt">{{$t('选择收货地址')}}</div>
						<el-link type="info" @click="goUrl('/address')" v-if="$store.state.isLoginStatu">{{$t('管理收货地址')}}</el-link>
					</div>
					<template v-if="$store.state.isLoginStatu">
						<el-skeleton v-if="skeleton" />
						<template v-else>
							<div class="panel-select" v-if="addressData && addressData.length > 0"
								style="margin-bottom: 20px;">
								<el-row :gutter="30">
									<el-col :span="8" v-for="(item, index) in addressData" :key="index">
										<div class="panel-select-card"
											:class="{ on: item.id == addressCur }" @click="addressSelect(index,item.id)">
											<div class="s-card-title">
												<span class="s-name">{{item.name}}</span>  <span>{{item.phone}}</span>
											</div>
											<div class="s-card-desc">
												<span>{{item.provinces}}</span> - <span>{{item.area}}</span> - <span>{{item.wards}}</span>  {{item.detail}}
											</div>
											
										</div>
									</el-col>
								</el-row>
							</div>
							<div class="address-empty" v-else>
								<empty></empty>
							</div>
						</template>
					</template>
					<template v-else>
						<div class="confirm-form">
							<el-form ref="addressform" :model="addressform">
								<el-form-item>
									<el-input v-model="addressform.address_name" :placeholder="$t('请输入姓名')"></el-input>
								</el-form-item>
								<el-form-item>
									<el-input v-model="addressform.address_phone" type="number" maxlength="10"
										:placeholder="$t('请输入手机号')"></el-input>
								</el-form-item>
								<el-form-item>
									<el-row :gutter="16">
									      <el-col :span="8">
									        <el-select
									          v-model="addressform.address_provinces"
									          :placeholder="$t('请选择省份')"
									          @change="onProvinceChange"
									        >
									          <el-option
									            v-for="province in provinces"
									            :key="province.province_name"
									            :value="province.province_name"
									          >
									            {{ province.province_name }}
									          </el-option>
									        </el-select>
									      </el-col>
									      <el-col :span="8">
									        <el-select
									          v-model="addressform.address_area"
									          :placeholder="$t('请选择市区')"
									          @change="onDistrictChange"
									          :disabled="!addressform.address_provinces"
									        >
									          <el-option
									            v-for="district in districts"
									            :key="district.district_name"
									            :value="district.district_name"
									          >
									            {{ district.district_name }}
									          </el-option>
									        </el-select>
									      </el-col>
									      <el-col :span="8">
									        <el-select
									          v-model="addressform.address_wards"
									          :placeholder="$t('请选择乡镇')"
									          :disabled="!addressform.address_area"
									        >
									          <el-option
									            v-for="ward in wards"
									            :key="ward.ward_name"
									            :value="ward.ward_name"
									          >
									            {{ ward.ward_name }}
									          </el-option>
									        </el-select>
									      </el-col>
									    </el-row>
								</el-form-item>
								<el-form-item>
									<el-input v-model="addressform.address_details"
										:placeholder="$t('请输入详细地址')"></el-input>
								</el-form-item>
							</el-form>
						</div>
					</template>
				</div>
				<div class="confirm-panel">
					<div class="confirm-panel_hd">
						<div class="tt">{{$t('支付方式')}}</div>
					</div>
					<div class="confirm-form">
						<el-form ref="addressform" :model="addressform">
							<el-form-item>
								<el-select v-model="addressform.pay_type" :placeholder="$t('请选择支付方式')"
									@change="changePayType" style="width: 100%;">
									<el-option :label="$t('在线支付')" value="1"></el-option>
									<el-option :label="$t('货到付款')" value="2"></el-option>
									<el-option :label="$t('银行转账')" value="3"></el-option>
								</el-select>
							</el-form-item>
						</el-form>
					</div>
					
				</div>
				<div class="confirm-panel">
					<div class="confirm-panel_hd">
						<div class="tt">{{$t('确认订单信息')}}</div>
					</div>
					<table class="bs-table ">
						<colgroup>
							<col width="36%">
							<col>
						</colgroup>
						<tbody>
							<tr>
								<th>{{$t('商品名称')}}</th>
								<th>{{$t('商品属性')}}</th>
								<th>{{$t('单价')}}</th>
								<th>{{$t('数量')}}</th>
								<th>{{$t('实付款')}}</th>
							</tr>
							<tr v-for="(item,index) in orderProduct" :key="index">
								<td>
									<div class="td-goods">
										<div class="td-goods-photo"><img :src="item.image" alt="" /></div>
										<div class="flex-col">
											<div class="td-goods-title">
												{{$t(item.title)}}
											</div>
										</div>
									</div>
								</td>
								<td>
									<div>{{$t('规格')}}：{{item.sku}}</div>
								</td>
								<td style="min-width: 200px;">{{formatNumber(item.unit_price)}} {{$t('VND')}}</td>
								<td>
									{{item.num}}
								</td>
								<td style="min-width: 200px;">
									{{ formatNumber(item.unit_price * item.num ) }} {{$t('VND')}}
								</td>
							</tr>
							<tr>
								<td colspan="5">
									<div class="confirm-foot">
										<el-form ref="form" label-position="left" :model="form" label-width="170px" v-if="$store.state.isLoginStatu">
											<el-form-item :label="$t('选择使用优惠券')">
												<el-select v-model="form.coupon" :placeholder="$t('选择使用优惠券')"
													@change="couponChange">
													<el-option
													            :value="null" 
													            :label="$t('不使用优惠券')" 
													            >
													        </el-option>
													<el-option v-for="(item,indexI) in myCoupons" :key="item.id"
														:value="item.id"
														:label="formatNumber(item.reduce) + $t('VND') + $t('优惠券')">
														<span>{{formatNumber(item.reduce)}}{{$t('VND')}}{{$t('优惠券')}}</span>
													</el-option>
												</el-select>
											</el-form-item>
											<el-form-item >
												<div slot="label">
													{{$t('是否使用积分抵扣')}} <br>
													({{formatNumber(dividends - dividendsLess)}} {{$t('积分')}})
												</div>
												 <el-radio-group v-model="form.is_integral" @input="integralChange">
												    <el-radio :label="0">
														{{$t('不使用')}}
													</el-radio>
													<el-radio :label="1">
														{{$t('使用')}}
													</el-radio>
												  </el-radio-group>
											</el-form-item>
										</el-form>
										<div class="totaol-price " style="margin-left: auto;">
											<div class="item" v-if="$store.state.isLoginStatu">
											      {{$t('积分抵消')}}：
											      <span class="price-v text-primary">
												  {{ formatNumber(dividendsLess) }} {{$t('VND')}}
												  </span>
											</div>

											<div class="item" v-if="$store.state.isLoginStatu">{{$t('优惠券减免')}}：<span
													class="price-v text-primary">{{ formatNumber(discountAmount) }}
													{{$t('VND')}}</span></div>
											<div class="item" style="font-size: 18px;">{{$t('合计')}}：<span
													class="price-v text-primary">{{ formatNumber(finalAmount) }}
													{{$t('VND')}}</span></div>
										</div>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="agreement-foot">
					<el-checkbox v-model="agrreChecked">
						{{$t('同意本网站的条款和条件')}}
					</el-checkbox>
				</div>
				<div class="confirm-panel-foot">
					<el-button type="warning" class="btn-submit" round @click="goOrderAdd">{{$t('提交订单')}}</el-button>
				</div>
			</div>
		</div>
		<selectAddress ref="selectAddress" :addressData="addressData" @updateAddress="handleUpdateAddress"></selectAddress>
		<selectPayType ref="selectPayType"></selectPayType>
		<payDialog :payids="payids" :paramData="paramData" ref="payDialog"></payDialog>
		<van-popup v-model="addshow"  position="bottom" get-container="body" closeable class="bs-popup">
			<div class="bs-popup-head">
				<div class="bs-popup-tit">{{$t('选择收货地址')}}</div>
			</div>
			<div class="bs-popup-scroll">
				<div class="bs-popup-body">
					<el-form ref="addressform" :model="addressform">
						
						<el-form-item>
							<el-input v-model="addressform.address_name" :placeholder="$t('请输入姓名')"></el-input>
						</el-form-item>
						<el-form-item>
							<el-input v-model="addressform.address_phone" type="number" maxlength="10"
								:placeholder="$t('请输入手机号')"></el-input>
						</el-form-item>
						<el-form-item>
							<el-select
							style="width: 100%;"
							  v-model="addressform.address_provinces"
							  :placeholder="$t('请选择省份')"
							  @change="onProvinceChange"
							>
							  <el-option
							    v-for="province in provinces"
							    :key="province.province_name"
							    :value="province.province_name"
							  >
							    {{ province.province_name }}
							  </el-option>
							</el-select>
						</el-form-item>
						<el-form-item>
							<el-select
							style="width: 100%;"
							  v-model="addressform.address_area"
							  :placeholder="$t('请选择市区')"
							  @change="onDistrictChange"
							  :disabled="!addressform.address_provinces"
							>
							  <el-option
							    v-for="district in districts"
							    :key="district.district_name"
							    :value="district.district_name"
							  >
							    {{ district.district_name }}
							  </el-option>
							</el-select>
						</el-form-item>
						<el-form-item>
							<el-select
							style="width: 100%;"
							  v-model="addressform.address_wards"
							  :placeholder="$t('请选择乡镇')"
							  :disabled="!addressform.address_area"
							>
							  <el-option
							    v-for="ward in wards"
							    :key="ward.ward_name"
							    :value="ward.ward_name"
							  >
							    {{ ward.ward_name }}
							  </el-option>
							</el-select>
						</el-form-item>
						<el-form-item>
							<el-input v-model="addressform.address_details" :placeholder="$t('请输入详细地址')"></el-input>
						</el-form-item>
						
						
					</el-form>
					<button class="layui-btn layui-btn-primary layui-btn-add" @click="verForm">
						+{{$t('新增地址')}}
					</button>
				</div>
			</div>
		</van-popup>
		<payBankDialog ref="payBankDialog"></payBankDialog>
	</div>
</template>
<script>
	import axios from 'axios';
	import payDialog from "@/components/payDialog"
	import payBankDialog from "./components/payBankDialog.vue"
	import empty from "@/components/empty"
	import helper from '@/common/helper.js';
	import {
		order_add_api,
		get_coupon_api,
		address_api,
		order_pay_api,
		payment_lists_api
	} from "@/api/user"
	import selectPayType from './components/selectPayType'
	import selectAddress from './components/selectAddress'
	export default {
		components: {
			selectAddress,
			selectPayType,
			payDialog,
			payBankDialog,
			helper,
			empty
		},
		data() {
			return {
				agrreChecked:false,
				skeleton: true,
				addressform: {
					pay_type: '',
					address_name: '',
					address_phone: '',
					address_provinces:'',
					address_area:'',
					address_wards:'',
					address_details: '',
				},
				provinces: [],
				districts: [],
				wards: [],
				form: {
					coupon: '',
					is_integral: 0,
				},
				addressData: [],
				addressCur: 0,
				wallet: [{
						title: "钱包余额支付",
						isdefault: true
					},
					{
						title: "钱包余额支付",
						isdefault: false
					}
				],
				walletCur: 0,
				orderProduct: [],
				goodsids: 0,
				goods: '',
				address_id: 0,
				notes: '',
				payids: "",
				paramData: null,
				cid: '',
				myCoupons: null,
				addshow: false,
				isAdd: false,
				dividends:'',
				defaultAddress:[],
				navRules: [],
				paymentData:null,
			};
		},
		computed: {
			totalPrice() {
				return this.orderProduct.reduce((total, item) => {
					return total + (item.unit_price * item.num);
				}, 0);
			},
			
			defaultWallet() {
				const defaultWallet = this.wallet.find(item => item.isdefault);
				return defaultWallet || this.wallet[0] || null;
			},
			discountAmount() {
				if (this.cid && this.cid !== 0) {
					const coupon = this.myCoupons.find(c => c.id === this.cid);
					return coupon ? coupon.reduce : 0;
				}
				return 0;
			},
			dividendsLess() {
			  let total = 0;
			  this.orderProduct.forEach(item => {
				total += item.unit_price * item.num;
			  });
			  return this.form.is_integral === 1 && this.dividends >= total ? total : (this.form.is_integral === 1 ? this.dividends : 0);
			},
			finalAmount() {
				// 计算最终付款金额
				return this.totalPrice - this.discountAmount - this.dividendsLess;
			}
		},
		methods: {
			
			handleUpdateAddress(addressId) {
				this.address_id = addressId
				const selectedAddress = this.addressData.find(address => address.id === addressId);
				if (selectedAddress) {
					this.defaultAddress = selectedAddress
				} else {
					console.warn("No address found for ID:", this.addressCur);
				}
			},
			integralChange(e){
				console.log(e)
			},
			changePayType(e) {
				console.log(e)
			},
			addressSelect(index, address_id) {
				this.addressCur = address_id;
				this.address_id = address_id;
			},
			changeTab(index) {
				this.curTab = index;
			},
			showAddress() {
				this.$refs.selectAddress.show = true
			},
			showWallet() {
				this.$refs.selectPayType.show = true
			},
			async getAddress() {
				this.skeleton = true
				await address_api().then(res => {
					if (res && res.data.code == 1) {
						this.addressData = res.data.data.list
						this.skeleton = false
						if (this.addressData.length > 0) {
							this.address_id = this.addressData[0].id
							this.addressCur = this.addressData[0].id
							this.defaultAddress = this.addressData[0]
						}
					} else {
						this.skeleton = false
					}
				});
			},
			couponChange(val) {
				this.cid = val; // 存储选择的优惠券 ID
			},

			async getCoupon() {
				let param = {
					goods_id: this.goodsids
				}
				await get_coupon_api(param).then(res => {
					if (res && res.data.code == 1) {
						this.myCoupons = res.data.data
					}
				});
			},
			verForm() {
				
				if (this.addressform.address_name == "") {
					this.errorTips("请输入姓名");
					return false;
				}
				if (this.addressform.address_phone == "") {
					this.errorTips("请输入手机号");
					return false;
				}
				const phoneReg = /^(0\d{9}|\d{9})$/;
				if (!phoneReg.test(this.addressform.address_phone)) {
					this.errorTips('请输入正确的手机格式');
					return;
				}
				if (this.addressform.address_provinces == "") {
					this.errorTips('请选择省份');
					return false;
				}
				if (this.addressform.address_area == "") {
					this.errorTips('请选择市区');
					return false;
				}
				if (this.addressform.address_wards == "") {
					this.errorTips('请选择乡镇');
					return false;
				}
				if (this.addressform.address_details == "") {
					this.errorTips("请输入详细地址");
					return false;
				}
				if (this.addressform.pay_type == "") {
					this.errorTips("请选择支付方式");
					return false;
				}
				if (!this.agrreChecked) {
					this.errorTips('请勾选平台服务协议');
					return false;
				}
				this.addshow = false
				this.isAdd = true
			},
			async goOrderAdd() {
				if (this.$store.state.isLoginStatu && this.addressData.length == 0) {
					this.errorTips("请添加收货地址");
					return false;
				}
				
				if (!this.$store.state.isLoginStatu) {

					if (this.addressform.address_name == "") {
						this.errorTips("请输入姓名");
						return false;
					}
					if (this.addressform.address_phone == "") {
						this.errorTips("请输入手机号");
						return false;
					}
					const phoneReg = /^(0\d{9}|\d{9})$/;
					if (!phoneReg.test(this.addressform.address_phone)) {
						this.errorTips('请输入正确的手机格式');
						return;
					}
					if (this.addressform.address_provinces == "") {
						this.errorTips('请选择省份');
						return false;
					}
					if (this.addressform.address_area == "") {
						this.errorTips('请选择市区');
						return false;
					}
					if (this.addressform.address_wards == "") {
						this.errorTips('请选择乡镇');
						return false;
					}
					if (this.addressform.address_details == "") {
						this.errorTips('详细地址');
						return false;
					}
				}
				if (this.addressform.pay_type == "") {
					this.errorTips("请选择支付方式");
					if (this.isMobileFlag) {
						this.addshow = true
					}
					return false;
				}
				
				if (!this.agrreChecked) {
					this.errorTips('请勾选平台服务协议');
					return false;
				}
				
				let param = {
					goods: JSON.stringify(this.orderProduct),
					address_id: this.address_id,
					notes: ' ',
					pay_type: this.addressform.pay_type,
					is_integral:this.form.is_integral,
					cid: this.cid,
				}
				if (!this.$store.state.isLoginStatu) {
						param["address_name"] = this.addressform.address_name,
						param["address_phone"] = this.addressform.address_phone,
						param["address_provinces"] = this.addressform.address_provinces,
						param["address_area"] = this.addressform.address_area,
						param["address_wards"] = this.addressform.address_wards,
						param["address_details"] = this.addressform.address_details,
						param["uuid"] = helper.get('uuid') || ''
				}
				const loading = this.$loading({
					lock: true,
					text: '',
					spinner: 'loader',
					background: 'rgba(255, 255, 255, 0.3)'
				});
				await order_add_api(param).then(res => {
					if (res && res.data.code == 1) {
						this.payids = res.data.data.join(',')
						if (this.addressform.pay_type == '1') {
							this.onPay()
						}else if (this.addressform.pay_type == '3') {
							this.$refs.payBankDialog.payInfoShow = true
						} else {
							this.goUrl('/pay-sucess')
							helper.rm('ConfirmProductData')
						}
					} else {
						this.errorTips(res.data.msg)
					}
					loading.close()
				});
			},
			async onPay() {
				let data = {
					id: this.payids,
				}
				if (!this.$store.state.isLoginStatu) {
					data["uuid"] = helper.get('uuid') || ''
				}
				const loading = this.$loading({
					lock: true,
					text: '',
					spinner: 'loader',
					background: 'rgba(255, 255, 255, 0.3)'
				});
				await order_pay_api(data).then(res => {
					if (res && res.data.code == 1) {
						if(res.data.data == ''){
							this.successTips("支付成功");
							this.goUrl('/pay-sucess')
							return false
						}else{
							this.platUrl(res.data.data)
						}
						helper.rm('ConfirmProductData')
						loading.close()
						this.updateUserInfo()
					} else {
						this.errorTips(res.data.msg)
						loading.close()
					}
				});
			},
			fetchProvinces() {
				axios.get('https://apisandbox.ntlogistics.vn/v1/loc/provinces', {
						headers: {
							'username': 'bbeauty',
							'password': 'dbea3cef248d01e6f4d3d61c6149a8fc482c1751'
						}
					})
					.then(response => {
						this.provinces = response.data.data;
					})
					.catch(error => {
						console.error('Error fetching provinces:', error);
					});
			},
			onProvinceChange(provinceName) {
				this.addressform.address_provinces = provinceName;
				const selectedProvince = this.provinces.find(province => province.province_name === provinceName);
				this.fetchDistricts(selectedProvince.id);
			},
			fetchDistricts(provinceId) {
				axios.get(`https://apisandbox.ntlogistics.vn/v1/loc/districts?province_id=${provinceId}`, {
						headers: {
							'username': 'bbeauty',
							'password': 'dbea3cef248d01e6f4d3d61c6149a8fc482c1751'
						}
					})
					.then(response => {
						this.districts = response.data.data;
						this.addressform.address_area = ''; // 清空市区选择
						this.wards = []; // 清空街道选择
					})
					.catch(error => {
						console.error('Error fetching districts:', error);
					});
			},
			onDistrictChange(districtName) {
				this.addressform.address_area = districtName;
				const selectedDistrict = this.districts.find(district => district.district_name === districtName);
				this.fetchWards(selectedDistrict.id);
			},
			fetchWards(districtId) {
				axios.get(`https://apisandbox.ntlogistics.vn/v1/loc/wards?district_id=${districtId}`, {
						headers: {
							'username': 'bbeauty',
							'password': 'dbea3cef248d01e6f4d3d61c6149a8fc482c1751'
						}
					})
					.then(response => {
						this.wards = response.data.data;
						this.addressform.address_wards = ''; // 清空街道选择
					})
					.catch(error => {
						console.error('Error fetching wards:', error);
					});
			},
			
		},
		mounted() {
			this.getAddress()
			this.orderProduct = helper.get('ConfirmProductData') || []
			if(!this.orderProduct || this.orderProduct == ''){
				this.goUrl('/my-order')
			}
			if(helper.get('userInfo')){
				this.dividends = helper.get('userInfo').user_money
			}
			this.goodsids = this.orderProduct[0].goods_id || ""
			if(this.$store.state.isLoginStatu){
				this.getCoupon()
			}
			this.fetchProvinces()
			if(this.$helper.get('topNavs')){
				this.navRules = this.$helper.get('topNavs').filter(item => item.is_nav === 6);
			}
		},
		beforeRouteLeave(to, from, next) {
			helper.rm('ConfirmProductData')
			next()
		}
	};
</script>
<style scoped>
	.confir-foot {
		display: flex;
		justify-content: space-between;
		text-align: right;
	}

	.confir-item:first-child {
		margin-bottom: 10px;
	}

	.td-goods {
		display: flex;
	}

	.td-goods-photo {
		font-size: 0;
		margin-right: 20px;
	}

	.td-goods-photo img {
		width: 100px;
		height: 100px;
	}

	.td-goods .flex-col {
		padding: 20px 0;
	}

	.m-select-card {
		padding: 10px;
		display: flex;
		align-items: center;
		background: #FFFFFF;
		border: 1px dashed #8B6E35;

	}

	.m-select-card .m-card-title {
		margin-bottom: 5px;
	}
	.m-card-title .s-name{
		margin-right: 10px;
	}
	.m-select-card .m-card-desc {
		display: flex;
		font-size: 12px;
		color: #666;

	}

	.m-select-card .m-card-desc div {
		margin-right: 10px;
	}

	.m-select-card .icon-address {
		font-size: 20px;
		margin-right: 10px;
	}

	.m-pay-cell {
		display: flex;
		align-items: center;
		padding: 12px 0;
		border-bottom: 1px solid #909090;

	}

	.m-pay-cell .icon-qianbao {
		margin-right: 10px;
		font-size: 20px;
	}

	.order-tabber {
		position: fixed;
		height: 60px;
		bottom: 0;
		left: 0;
		right: 0;
		z-index: 99;
		display: flex;
		align-items: center;
		padding: 0 15px;
		background: #FFFFFF;
		font-size: 13px;
		box-shadow: 0px 1px 38px 0px rgba(113, 53, 0, 0.11);

	}

	.order-tabber .el-button {
		border-radius: 30px;
	}

	.m-goods-cell {
		padding: 20px 0;
		border-bottom: 1px solid #dcdcdc;
	}

	.m-goods-row {
		display: flex;
	}

	.m-goods-row .m-photo {
		margin-right: 10px;

	}

	.m-goods-row .m-photo img {
		width: 60px;
		height: 60px;
	}

	.m-goods-item {
		font-size: 13px;
		display: flex;

	}

	.m-goods-item .item-price {
		margin-left: auto;
	}

	.m-goods-title {
		font-size: 16px;
	}

	.input-number-row {
		display: flex;
		justify-content: flex-end;
		margin-top: 10px;
	}

	.m-goods {
		margin-bottom: 20px;
	}

	.address-empty {
		height: 200px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.confirm-form {
		width: 50%;
	}

	@media (max-width:1200px) {
		.confirm-form {
			width: 100%;
		}
	}
	.confirm-m-foot ::v-deep .el-form--label-top .el-form-item__label{
		line-height: 20px;
	}

	.layui-btn-add {
		width: 100%;
	}
	.confirm-foot ::v-deep .el-form-item__label{
		line-height: 20px;
		padding: 8px 0;
	}
	
	.agreement-foot{
		display: flex;
		align-items: center;
		flex-wrap:wrap;
		margin-top: 20px;
	}
	@media (min-width:1000px) {
		.agreement-foot{
			margin-bottom: 20px;
			margin-top: 0;
			justify-content: flex-end;
		}
	}
	.ml-6{
		margin-left: 6px;
	}
	
	
	
	
	
</style>